import React, {Component} from 'react';
import './Announcement.css';
import Parser from 'html-to-react';
import ShowMoreText from 'react-show-more-text';
import {Link} from "react-router-dom";

class AnnouncementBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputAnnouncementList: [],
            };
    }

    componentDidMount() {
        let inputAnnouncementList=this.props.inputAnnouncementList;
        this.setState({inputAnnouncementList: inputAnnouncementList});
    }

    render() {

        let HtmlToReactParser = Parser.Parser;
        let htmlToReactParser = new HtmlToReactParser();

        return (
            <div className="announcement-block">
                {this.props.inputAnnouncementList.map((announcement) =>
                    <div className="announcement-block-item-container col-sm-12">
                        <div className="announcement-title row col-sm-12">{announcement.title}</div>
                        <div style={{lineHeight:"30px"}} className="col-sm-12">
                        <div className="announcement-date right row">{new Date(announcement.startDate).toLocaleDateString('tr') }</div>
                        </div>
                        <div className="announcement-block-item-content row col-sm-12">
                        <ShowMoreText
                            lines={3}
                            anchorClass='announcement-truncated-text'
                            expanded={false}>
                            {htmlToReactParser.parse(announcement.text)}
                        </ShowMoreText>
                        </div>
                        <div style={{lineHeight:"30px"}} className="col-sm-12">
                            <div className="announcement-link row right">
                                <Link to={{pathname:'/announcementItem/'+announcement.id , selectedAnnouncement:{announcement}}} >
                                    Devamı için tıklayınız.
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default AnnouncementBlock;


// WEBPACK FOOTER //
// ./src/page/announcement/AnnouncementBlock.js